import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { MongoResource } from '../../shared/mongo.resource';
import { Feedback } from './feedbacks.model';
import { HttpClient } from '@angular/common/http';

// @Injectable()
// export class AnnouncementsService {

//     constructor() { }

// }

@Injectable()
export class FeedbacksService extends MongoResource<any, Feedback, Feedback> {

  baseUrl = environment.api + 'feedbacks';

  public createChatroom(feedbackId, chatId): Observable<Feedback> {
    return this.$post<any, Feedback>(feedbackId + '/chat/' + chatId);
  }

  getAllTypes(): Observable<any[]> {
    return this.$get('types');
  }

  findAll(): Observable<Feedback[]> {
    return this.$get('findAll');
  }

  constructor(public http: HttpClient) { super(http); }

  public assign(_id: string, action: string, assignment: any) {
    return this.$post(_id + '/' + action, assignment);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/shared/feedbacks.service.ts